// extracted by mini-css-extract-plugin
export default {"circle":"PageLoader_circle__l8EbI","dote":"PageLoader_dote__edyh5","animate":"PageLoader_animate__Tzdip"};